import React, {ContextType} from 'react';

import {
  Atom,
  withSystem,
  Plugins,
  type AtomRenderProps,
} from '@packages/systems/wfdl';
import {
  iconName,
  qualify,
  pluginName,
  typeName,
} from '@packages/systems/wfdl-Qualified';
import {TListOfElement, TTypeConstructor} from '@packages/systems/wfdl-ast';
import {createDevlinkAtom} from '@packages/utilities/integrated-types';
import {
  EvaluatedNodeData,
  getChildren,
  getInPojo,
  getTagOrElse,
} from '@packages/utilities/data-utils';
import {List} from 'immutable';
import {MENU_STATE_SHOW} from '@packages/utilities/expression-path-constants';

// @ts-expect-error - TS2314 - Generic type 'ContextType' requires 1 type argument(s).
const maybeAddOpen = (context: ContextType) => (classes: List<string>) => {
  return context.get('menu') === MENU_STATE_SHOW
    ? classes.push('w--open')
    : classes;
};

const DropdownList = Atom.createRender(
  ({
    attributes,
    classes,
    generateAttributes,
    data,
    context,
    renderChild,
  }: AtomRenderProps) => {
    const Tag = getTagOrElse(getInPojo(data, ['tag']), 'nav');
    const dropdownListClasses = classes
      .push('w-dropdown-list')
      .update(maybeAddOpen(context));
    return (
      <Tag {...generateAttributes(attributes, dropdownListClasses)}>
        {getChildren(data).map((child: EvaluatedNodeData) =>
          renderChild(child)
        )}
      </Tag>
    );
  }
);

const config = createDevlinkAtom({
  displayName: 'Dropdown List',
  icon: {
    type: 'Component',
    value: qualify(Plugins.name('Dropdown'), iconName('DropdownList')),
  },
  showEmpty: true,
  constraints: {
    pinToParent: true,
    ancestors: [
      {
        is: 'DropdownWrapper',
        rule: 'AtLeastOne',
      },
    ],
  },
  render: DropdownList,
  fields: {
    tag: withSystem(
      {
        label: 'Tag',
        private: true,
        defaultValue: 'Nav',
      },
      TTypeConstructor(qualify(pluginName('Basic'), typeName('TagsDropdown')))
    ),
    children: TListOfElement,
  },
});

export default config;
